import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

export const values = [
  {
    label: 'Distributors',
    value: PartnerType.Distributor,
  },
  { label: 'Commercial Resellers', value: PartnerType.Commercial },
]

export const valuesForNotSuperAdmin = [
  { label: 'Commercial Resellers', value: PartnerType.Commercial },
]
